/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as CheckboxDefault } from './checkbox-default.story';
export { default as CheckboxIndeterminate } from './checkbox-indeterminate.story';
export { default as CheckboxNoLabel } from './checkbox-no-label.story';
export { default as CheckboxDisabled } from './checkbox-disabled.story';
export { default as CheckboxHasLabelBefore } from './checkbox-has-label-before.story';
export { default as CheckboxFull } from './checkbox-full.story';
export { default as CheckboxControlled } from './checkbox-controlled.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import CheckboxControlledSrcRaw from './checkbox-controlled.story?raw';
import CheckboxDefaultSrcRaw from './checkbox-default.story?raw';
import CheckboxDisabledSrcRaw from './checkbox-disabled.story?raw';
import CheckboxFullSrcRaw from './checkbox-full.story?raw';
import CheckboxHasLabelBeforeSrcRaw from './checkbox-has-label-before.story?raw';
import CheckboxIndeterminateSrcRaw from './checkbox-indeterminate.story?raw';
import CheckboxNoLabelSrcRaw from './checkbox-no-label.story?raw';

export const CheckboxDefaultSrc = removeLicenseHeader(CheckboxDefaultSrcRaw);
export const CheckboxIndeterminateSrc = removeLicenseHeader(
  CheckboxIndeterminateSrcRaw,
);
export const CheckboxNoLabelSrc = removeLicenseHeader(CheckboxNoLabelSrcRaw);
export const CheckboxDisabledSrc = removeLicenseHeader(CheckboxDisabledSrcRaw);
export const CheckboxFullSrc = removeLicenseHeader(CheckboxFullSrcRaw);
export const CheckboxHasLabelBeforeSrc = removeLicenseHeader(
  CheckboxHasLabelBeforeSrcRaw,
);
export const CheckboxControlledSrc = removeLicenseHeader(
  CheckboxControlledSrcRaw,
);
